<template>
  <div>
    <v-container>
      <v-layout justify-center row wrap>
        <v-flex xs12 text-xs-center>
          <img src="/pricing-devices.png" style="max-width: 494px; width: 100%">
        </v-flex>
        <v-flex xs12>
          <v-container ma-0 pa-0>
            <v-layout row wrap justify-center>
              <v-flex
                xs12
                sm3
                pa-1
                text-xs-center
              >
                <div>
                  <p class="headline my-3">School</p>
                  <p class="subheading my-3 desc">All students and teachers, on any device, from school and at home.</p>
                  <v-btn
                    outline
                    href="order-form.pdf"
                    target="_blank"
                  >
                    Select
                  </v-btn>
                  <p class="title my-3">$495<sup><span style="font-weight: 300">/yr</span></sup></p>
                </div>
              </v-flex>
              <v-flex
                xs12
                sm3
                pa-1
                text-xs-center
              >
                <div>
                  <p class="headline my-3">District</p>
                  <p class="subheading my-3 desc">All students and teachers, on any device, from school and at home.</p>
                  <a href="mailto:sales@brainingcamp.com?subject=Classlink District Inquiry">
                    <v-btn
                      my-3
                      flat
                      white
                    >
                      Contact Us
                    </v-btn>
                  </a>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
        <v-flex xs12 text-xs-center mt-5>
          <p class="headline font-weight-bold accent--text">Questions?</p>
          <p class="title my-1 desc">Call 888.967.2267 or email <a href="mailto:sales@brainingcamp.com">sales@brainingcamp.com</a></p>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container style="background: #e2e2e2" fluid>
      <v-container>
        <v-layout column>
          <v-flex xs12 subheading my-2>
            <p><span class="faq-title">W-9.</span> Please email sales@brainingcamp.com for a W-9.</p>
          </v-flex>
          <v-flex xs12 subheading my-2>
            <p><span class="faq-title">PURCHASE ORDERS.</span> Please download this order form which can be used with your purchase orders.</p>
          </v-flex>
          <v-flex xs12 subheading my-2>
            <p><span class="faq-title">COUNTRIES AND CURRENCIES.</span> Please email sales@brainingcamp.com for a local quote and payment options.</p>
          </v-flex>
          <v-flex xs12 subheading my-2>
            <p><span class="faq-title">START AND END DATES.</span> Licenses are for 12-month terms that start when orders are received and processed. Please indicate on your order or contact us if you want a different start date. You may also contact us to discuss any special circumstances requiring a term different from 12-months. </p>
          </v-flex>
          <v-flex xs12 subheading my-2>
            <p><span class="faq-title">STUDENT DATA AND PRIVACY.</span> Because manipulatives are more like open-ended tools than personalized curriculum, students share generic accounts that contain absolutely no personally identifiable data. Brainingcamp is designed so students remain completely anonymous, without collecting, capturing, using, storing, or accepting any personally identifiable confidential student data.</p>
          </v-flex>
          <v-flex xs12 subheading my-2>
            <p><span class="faq-title">APPROVED VENDOR.</span> If you are unsure whether we are an approved vendor, or need help getting us setup as an approved vendor, please contact sales@brainingcamp.com.</p>
          </v-flex>
        </v-layout>
      </v-container>
    </v-container>
  </div>
</template>

<script>

export default {
}
</script>

<style scoped>
.desc {
  font-weight: 300;
}

.flag-sizer {
  font-size: 28px;
  border-radius: 50%;
  cursor: pointer;
}

.large-flag {
  font-size: 52px;
  border-radius: 50%;
}

.v-btn >>> .v-btn__content {
  color: #3296f3
}

.faq-title {
  color:#3296f3;
  font-weight:bold;
  text-transform: uppercase;
}
</style>
